import 'css-chunksrc/client/pages/projectPage/timeSheetPage/allocations/allocation/task/styles.scss';export default {
  "list": "_list_15i4b_1",
  "main": "_main_15i4b_6",
  "header": "_header_15i4b_12",
  "iconBox": "_iconBox_15i4b_23",
  "icon": "_icon_15i4b_23",
  "openedIcon": "_openedIcon_15i4b_39",
  "row": "_row_15i4b_43",
  "avatar": "_avatar_15i4b_50",
  "col": "_col_15i4b_55",
  "name": "_name_15i4b_64",
  "profession": "_profession_15i4b_73",
  "recordList": "_recordList_15i4b_78",
  "noAllocationBadge": "_noAllocationBadge_15i4b_82",
  "removedBadge": "_removedBadge_15i4b_95"
};